import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=010372e4&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=010372e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010372e4",
  null
  
)

export default component.exports